{
  "name": "@eventcatalog/generator-github",
  "version": "0.2.2",
  "description": "Pull and Sync schemas from GitHub to EventCatalog",
  "scripts": {
    "build": "tsup",
    "test": "vitest",
    "format": "prettier --write .",
    "format:diff": "prettier --list-different .",
    "changeset": "changeset",
    "release": "changeset publish"
  },
  "publishConfig": {
    "access": "public"
  },
  "keywords": [
    "eventcatalog",
    "generator",
    "github"
  ],
  "author": "EventCatalog",
  "license": "ISC",
  "devDependencies": {
    "@changesets/cli": "^2.27.10",
    "@types/fs-extra": "^11.0.4",
    "@types/node": "^20.16.1",
    "prettier": "^3.3.3",
    "tsup": "^8.1.0",
    "typescript": "^5.5.3",
    "vitest": "^2.0.2"
  },
  "files": [
    "dist",
    "package.json"
  ],
  "main": "./dist/index.js",
  "module": "./dist/index.mjs",
  "types": "./dist/index.d.ts",
  "dependencies": {
    "@eventcatalog/sdk": "^2.0.0",
    "chalk": "4.1.2",
    "fs-extra": "^11.2.0",
    "update-notifier": "^7.3.1"
  }
}
